export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration.vue?vue&type=template&id=487fac76&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/registration.vue?vue&type=template&id=487fac76&scoped=true
// module id = nLjo
// module chunks = 0